import styled from 'styled-components';

export const GroupEventListWrapper = styled.ul`
    & > li:nth-child(odd) {
        background-color: #fff;
    }
    & > li:nth-child(even) {
        background-color: #f0f4fa;
    }
`;

export const ViewTournamentListWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    gap: ${({ $gap }) => ($gap ? $gap : '0')};
`;
